const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the assignment template distribute component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('distributeAssignmentTemplate', ['AssignmentTemplates', 'Assignments', 'Features', 'Messaging', 'AdminUsers', '$translate', function(AssignmentTemplates, Assignments, Features, Messaging, AdminUsers, $translate) {
  return {
    restrict: 'E',
    scope: {
      templateid: '=',
      manager: '=?',
      cancel: '&?',
      file: '=?'
    },
    template: require('../../../templates/directives/assignments/distribute-assignment-template.html'),
    controller: ['$scope', function ($scope) {
      const self = this;
      self.assignmentTemplates = Features.flags().enable_assignment_templates;

      if (!self.assignmentTemplates) {
        Navigation.goToHome();
        return;
      }

      self.initialized = false;
      self.saving = false;
      self.content = [];
      self.selectionCount = 0;
      self.per_page = 20;

      self.tabs = {
        current: 'users',
        order: ['users', 'preview'],
        showNext: function() {
          return self.tabs.current !== self.tabs.order[self.tabs.order.length - 1];
        },
        changeTab: function(direction) {
          const add = direction === 'next' ? 1 : -1;
          let place = self.tabs.order.indexOf(self.tabs.current);
          place = place === -1 ? 0 : place;

          if (self.tabs.current === 'users') {
            if (self.selectionCount < 1) {
              return;
            }
          }

          if (self.tabs.order[place + add] === 'preview') {
            self.preview.page = 1;
            self.preview.getUsers();
          }
  
          self.tabs.current = self.tabs.order[place + add];
        },
        navigate: function(tab) {
          if (self.tabs.current === 'users' && tab === 'preview') {
            if (self.selectionCount < 1) {
              return;
            }
            
            self.preview.page = 1;
            self.preview.getUsers();
          }

          self.tabs.current = tab;
        }
      };

      self.settings = {};

      self.import = {
        uploadId: 'open-browse',
        openBrowse: function() {
          document.getElementById(this.uploadId).click();
        },
        parseEmails: function (event) {
          let emailString = event.target.result;
          let emailsArray;
          //json
          try {
            emailsArray = JSON.parse(emailString);
          } catch (error) {
            emailsArray = emailString.split(/[ ,\r\n]+/g);
            emailsArray.forEach((email, index) => {
              emailsArray[index] = email.trim()
            });
            emailsArray = emailsArray.filter((email) => {
              return email!=='' && email!=='email'
            });
          }
          emailString = emailsArray.join(',');
          let length = emailsArray.length;
          const query = {
            fields: '_id,email',
            per_page: 10000,
            email: `$in,${length},${emailString}`
          }
          let promise = AdminUsers.findFromQuery({},query).$promise;
          promise.then(({users}) => {
            if (users.length === 0) {
              Application.messaging.addMessage({type: 'error', duration: 7, text: 'No users found. Please check user emails and see help documentation for allowed file formats'});
              return;
            }
            self.import.checkAndCount(users);
            self.changeTab('next', true);
            if(users.length !== emailsArray.length) {
              let messageText = `${users.length} of ${emailsArray.length} users have been successfully added to the assignment.`;
              Application.messaging.addMessage({type: 'info', duration: 6, text: messageText})
            }
          })
        },
        read: function() {
          const reader = new FileReader();
          reader.addEventListener('load', this.parseEmails);
          reader.readAsText($scope.file);
        },
        checkAndCount: function (users) {
          users.forEach((user) => {
            if (assignList.nin[user._id]) {
              delete assignList.nin[user._id];
            }
            assignList.in[user._id] = true;
          });
          getCount();
        }
      };

      const assignList = {
        in: {},
        nin: {},
        queries: []
      };

      self.individuals = {};
      var getStandardQuery = function(){
        var q = {
          subresource: '',
          page: 1,
          per_page: self.per_page,
          fields: '_id,first_name,last_name,email,full_name,role,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,job_title,last_login,createdAt,hired,manager_email',
          'linked_locations-populate': 'name',
          'linked_departments-populate': 'name',
          'linked_teams-populate': 'name',
          'linked_org_level-populate': 'name',
          'linked_grade-populate': 'name',
        };
        if ($scope.manager && $scope.manager.email) {
          q.manager_email = $scope.manager.email;
        } else {
          q.prioritize_creator = true;
        }
        return q;
      };

      self.query = getStandardQuery();

      self.load = function () {
        self.initialLoad = false;
        self.searchNext = true;
        var promise;
        if (self.managerQuery) {
          self.query.manager_query = true;
        }

        if (assignList.queries.length || assignList.in.length || assignList.nin.length) {
          var items = {};
          items.queries = assignList.queries;
          items.assignee_in = Object.keys(assignList.in);
          items.assignee_nin = Object.keys(assignList.nin);
          promise = AdminUsers.findFromQueryAndCheck({}, {find_query: self.query, match_query: items}).$promise
        } else {
          promise = AdminUsers.findFromQuery({}, self.query).$promise;
        }

        self.searchLoading = true;
        promise.then(function (results) {
          self.searchLoading = false;
          var users = results.users || [];
          self.selected_users = results.selected_users || [];
          if (users.length < self.per_page) {
            self.searchNext = false;
          }
          self.users = users;

        }).catch(function (error) {
          console.log('Error getting users:', error);
        });
      };

      self.nextPage = function() {
        if (self.lastAllSinglePage) {
          self.lastAllSinglePage = false;
          self.allChecked = false;
        }
        self.query.page++;
        self.load();
      };

      self.previousPage = function() {
        if (self.query.page <= 1) {
          return;
        }
        if (self.lastAllSinglePage) {
          self.lastAllSinglePage = false;
          self.allChecked = false;
        }
        self.query.page--;
        self.load();
      };

      self.onQuery = function(opts) {
        self.initialLoad = false;

        self.query = getStandardQuery();
        if (!opts || typeof opts === 'object' && !Object.keys(opts).length) {
          self.allChecked = false;
          self.load();
          return;
        }
        self.allChecked = false;
        self.query.page = 1;
        self.query.queries = [opts];
        self.load();
      };

      self.getLocation = function(user) {
        if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
          return user.linked_locations[0].name;
        }
        return '-----';
      };
      self.getDepartment = function(user) {
        if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
          return user.linked_departments[0].name;
        }
        return '-----';
      };
      self.getTeams = function(user) {
        if (user && user.linked_teams && user.linked_teams.length) {
          var steams = '';
          user.linked_teams.forEach(function (team) {
            steams += team.name + ', ';
          });
          return steams.slice(0, -2);
        }
        return '-----';
      };
      self.getOrgLevel = function(user) {
        if (user && user.linked_org_level) {
          return user.linked_org_level.name;
        }
        return '-----';
      };
      self.getGrade = function(user) {
        if (user && user.linked_grade) {
          return user.linked_grade.name;
        }
        return '-----';
      };

      self.preview = {
        page: 1,
        per_page: 20,
        nextAllowed: false,
        show: false,
        getUsers: function() {
          self.preview.show = true;

          var getBody = {
            fields: '_id,first_name,last_name,email,full_name,image,job_title,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,role,hired,createdAt,last_login',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            'linked_teams-populate': 'name',
            'linked_org_level-populate': 'name',
            'linked_grade-populate': 'name',
            page: self.preview.page,
            per_page: self.preview.per_page,
            queries: assignList.queries,
            assignee_in: Object.keys(assignList.in),
            assignee_nin: Object.keys(assignList.nin)
          };

          if (self.managerQuery) {
            getBody.manager_query = true;
          }

          AdminUsers.findFromQuery({}, getBody).$promise
          .then(function(users) {
            users = users.users || [];
            self.preview.users = users;
            if (users.length < self.preview.per_page) {
              self.preview.nextAllowed = false;
              return;
            }
            self.preview.nextAllowed = true;
          });
        },
        nextPage: function() {
          self.preview.page++;
          self.preview.getUsers();
        },
        previousPage: function() {
          if (self.preview.page) {
            self.preview.page--;
            self.preview.getUsers();
          }
        }
      };

      // Functions for selecting and deselecting users to assign
      self.userClick = function(user) {
        if (self.isUserChecked(user)) {
          self.uncheckUser(user);
          return;
        }
        self.checkUser(user);
      };
      self.checkUser = function(user, id) {
        id = id ? id : user._id;
        if (assignList.nin[id]) {
          delete assignList.nin[id];
        }
        assignList.in[id] = true;
        getCount();
      };
      self.uncheckUser = function(user, id) {
        id = id ? id : user._id;
        if (assignList.in[id]) {
          delete assignList.in[id];
        }
        assignList.nin[id] = true;
        getCount();
      };

      self.lastAllSinglePage = false;
      self.selectAll = function() {
        if (self.allChecked) {

          if (self.lastAllSinglePage) {
            self.users.map(user => {
              delete assignList.in[user._id];
            });
            self.lastAllSinglePage = false;
            self.allChecked = false;
            getCount();
            return;
          }

          assignList.queries.pop();
          self.lastAllSinglePage = false;
          self.allChecked = false;
          getCount();
          return;
        };

        self.allChecked = true;
       
        if (self.query._id) {
          self.checkUser(null, self.query._id);
          self.lastAllSinglePage = false;
          return;
        }

        var queryAddition = self.query && self.query.queries && self.query.queries[0];
        if (!queryAddition) {
          self.users.map(user => {
            delete assignList.nin[user._id];
            assignList.in[user._id] = true;
          });
          getCount();
          self.lastAllSinglePage = true;
          return;
        }

        if ($scope.manager) {
          queryAddition.manager_query = true;
        }

        assignList.queries.push(queryAddition);
        getCount();

      };

      self.isUserChecked = function(user) {
        self.individuals[user._id] = false;
        if (assignList.nin[user._id]) {
          return false;
        }

        if (assignList.in[user._id]) {
          self.individuals[user._id] = true;
          return true;
        }

        if (self.allChecked) {
          self.individuals[user._id] = true;
          return true;
        }

        if (self.selected_users.indexOf(user._id) !== -1) {
          self.individuals[user._id] = true;
          return true;
        }

        return false;
      };

      var getCount = function() {
        var items = {};
        items.queries = assignList.queries;
        items.assignee_in = Object.keys(assignList.in);
        items.assignee_nin = Object.keys(assignList.nin);
        items.count_only = true;
        if (!items.queries.length && !items.assignee_in.length) {
          self.selectionCount = 0;
          return;
        }
        if (self.managerQuery) {
          items.manager_query = true;
        }
        AdminUsers.findFromQuery({}, items).$promise
        .then(function(count) {
          self.selectionCount = count.count ? count.count : 0;
        });
      };

      // End functions for selecting and deselecting users to assign
      self.clearChoices = function() {
        assignList.in = {};
        assignList.nin = {};
        assignList.queries = [];
        self.individuals = {};
        self.selectionCount = 0;
        self.allChecked = false;
        self.clearQuery = true;
      };
      self.cancel = function() {
        if ($scope.cancel) {
          $scope.cancel();
          return;
        }
      };

      self.distribute = async function() {
        if (!self.selectionCount) {
          return;
        }

        const query = {
          queries: assignList.queries,
          in: Object.keys(assignList.in),
          nin: Object.keys(assignList.nin)
        };

        if (self.managerQuery) {
          query.manager_query = true;
        }

        try {
          await Assignments.distribute({remindid: $scope.templateid}, query).$promise;
          Messaging.addMessage({type: 'success', duration: 6, text: self.translations['assignmentTemplates.distribute.success']});
          $scope.cancel({changed: true});
        } catch (error) {
          Messaging.addMessage({type: 'error', duration: 6, text: self.translations['assignmentTemplates.distribute.error']});
          $scope.cancel();
        }

      };

      $scope.$watch('file', function(newVal, oldVal) {
        oldVal = oldVal || {};
        if (!newVal || typeof newVal !== 'object') {
          return;
        }
        if (newVal.name && newVal.name !== oldVal.name) {
          Messaging.addMessage({type: 'success', duration: 5, text: `"${$scope.file.name}" Imported Successfully`});
          self.import.read()
        }
      });

      if ($scope.manager && $scope.manager.email) {
        // **TODO ** Possibly send email data through this
        self.managerQuery = true;
      }

      if ((!self.users || !self.users.length) && $scope.manager) {
        self.query = getStandardQuery();
        self.load();
      }

      self.initialize = async function() {
        self.load();

        const template = await AssignmentTemplates.get({subresource: $scope.templateid}).$promise;

        self.settings = {
          title: template.title || false,
          non_reminder_messages: template.non_reminder_messages || [],
          reminder_messages: template.reminder_messages || [],
          overdue_messages: template.overdue_messages || [],
          use_due: template.use_due || false,
          due_date: template.days_to_complete || 30,
          due_from_hired: template.due_from_hired || false,
          due_days_after_hired: template.due_days_after_hired || 30,
          escalate_manager: template.escalate_manager || false,
          escalate_buddy: template.escalate_buddy || false,
          escalation_contacts: template.escalation_contacts || [],
          require_recompletion: template.require_recompletion || false
        };

        self.content = template.assigned_content.map(item => item.content_id);

        self.initialized = true;
        $scope.$apply();

      };

      self.saveChanges = async function() {

        self.saving = false;

      };

      self.close = function(refresh) {
        $scope.close({changed: refresh});
      };

      $translate([
        'assignmentTemplates.distribute.success',
        'assignmentTemplates.distribute.error'
      ]).then(function(translations){
        self.translations = translations;
      });

      self.initialize();

    }],
    controllerAs: 'distributeTemplate'
  };
}]);
